export const NsNumberInputConstants = Object.freeze({

  MAX_VALUE_EXCEEDED_ERROR_KEY: 1,
  MIN_VALUE_EXCEEDED_ERROR_KEY: 2
});
